import axios from 'axios';

export default {
  sendInvitation(projectId, email, isPrimary) {
    return axios.post(`/projects/${projectId}/collaborators`, { collaborator: { email, contact: isPrimary } });
  },
  getProjectCollaborators(projectId, succ) {
    axios.get(`/projects/${projectId}/collaborators`).then((response) => {
      succ(response.data);
    });
  },
  acceptInvitation(token) {
    return axios.post('/collaborators/confirm', token);
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/team.js